import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { showMenu } from 'react-contextmenu/modules/actions';

import useActionUser from './hooks/useActionUser';

function ActionUser({ userID, label, color, className, style }) {
  const el = useRef();
  const { isEnable, prepareContextMenu } = useActionUser(userID);

  const showContextMenu = () => {
    if (isEnable) {
      const nbMenus = prepareContextMenu(); // Based on permission
      const p = el.current.getBoundingClientRect();
      const parent = document.getElementById(`chat-messages`).getBoundingClientRect();
      const isOutsideBottom = ((p.bottom + (nbMenus * 20)) * 1.1 > parent.bottom);
      let position = p.top;
      if (isOutsideBottom) {
        position = (p.top + (nbMenus * 20)) - ((p.bottom + (nbMenus * 20)) - parent.bottom)
      }
      showMenu({
        position: {x: p.left + 250, y: position },
        target: {},
        id: `DynamicMenu`
      })
    }
  }

  return (
    <span ref={el} style={{ color, cursor: isEnable ? `pointer` : `initial` }} onClick={showContextMenu}>{label}</span>
  )
}

ActionUser.propTypes = {
  userID: PropTypes.any,
  label: PropTypes.string.isRequired,
  color: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
}

export default ActionUser;
